export default __webpack_public_path__ + "static/media/Minicard_3s.377d821f.svg";